module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Foreword"
    }
  }, [_c('strong', [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch01"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter One")]), _vm._v(" GETTING STARTED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch01#ch01lev1sec1"
    }
  }, [_vm._v("Get Organized")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch01#ch01lev1sec2"
    }
  }, [_vm._v("Get Inspired")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch01#ch01lev1sec3"
    }
  }, [_vm._v("Get Moving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch01#ch01lev1sec4"
    }
  }, [_vm._v("Deep Breath: Pat Yourself on the Back")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Two")]), _vm._v(" ATTIRE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch02#ch02lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Here Comes the Dress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch02#ch02lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Complete the Package")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch02#ch02lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Groom’s Outfit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch02#ch02lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bridesmaids’ Ensembles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch02#ch02lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: Relax, Gorgeous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Three")]), _vm._v(" INVITATIONS"), _c('br'), _vm._v("(and Other Ways to Spread the Word)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch03#ch03lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keep It Simple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch03#ch03lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invitation Options")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch03#ch03lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Save-the-Dates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch03#ch03lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wedding Web Site")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch03#ch03lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: Signed, Sealed, Delivered")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Four")]), _vm._v(" PHOTOS AND VIDEO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch04#ch04lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Photography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch04#ch04lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Video")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch04#ch04lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: Freeze Frame")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Five")]), _vm._v(" FOOD AND DRINK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch05#ch05lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Food")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch05#ch05lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Piece of Cake?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch05#ch05lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The DIY Bar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch05#ch05lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting the Table")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch05#ch05lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: Eat, Drink, and Be Married")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Six")]), _vm._v(" FLOWERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch06#ch06lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flower Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch06#ch06lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hand Flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch06#ch06lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corsages and Boutonnieres")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch06#ch06lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Centerpieces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch06#ch06lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: Nature’s Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Seven")]), _vm._v(" FAVORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch07#ch07lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edible Favors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch07#ch07lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Useful/Dual Purpose Favors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch07#ch07lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intangible Gifts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch07#ch07lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: Do Yourself a Favor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Eight")]), _vm._v(" RINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch08#ch08lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Have Your Rings Made")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch08#ch08lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rings with a Past")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch08#ch08lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: All That Glitters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Nine")]), _vm._v(" THE CEREMONY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09#ch09lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding an Officiant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09#ch09lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Make-Your-Own Minister")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09#ch09lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Writing Your Own Ceremony and/or Vows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09#ch09lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ceremony Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09#ch09lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decorate the Ceremony Space")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch09#ch09lev1sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: You Do")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Ten")]), _vm._v(" THE RECEPTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch10#ch10lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decorate the Reception Space")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch10#ch10lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reception Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch10#ch10lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Breath: It’s All Coming Together")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Chapter Eleven")]), _vm._v(" P.S. CRAFTILY EVER AFTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch11#ch11lev1sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The DIY Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch11#ch11lev1sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Rules Recap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch11#ch11lev1sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contracts 101")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch11#ch11lev1sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Team Assignments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Ch11#ch11lev1sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Acknowledgment",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ACKNOWLEDGMENTS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0